import type { ChangeEvent, FC, KeyboardEvent, WheelEvent } from "react";

import { InputNumberStyle } from "../../../../documentation/styles/InputStyle";
import type { FormInputProps } from "../../types/types";

interface NumberInputProps extends FormInputProps<string> {
    readOnly: boolean;
}

export const NumberInput: FC<NumberInputProps> = ({ onChange, readOnly, ...restProps }) => {
    const onValueChange = (ev: ChangeEvent<HTMLInputElement>) => {
        if (onChange) {
            onChange(ev.target.value);
        }
    };

    // Block characters that would let a value go negative or use scientific notation,
    // since search-form usages of this input don't have a Min validation rule attached.
    const onKeyDown = (ev: KeyboardEvent<HTMLInputElement>) => {
        if (ev.key === "e" || ev.key === "E" || ev.key === "-") {
            ev.preventDefault();
        }
    };

    // Blur on wheel so scrolling the page over a focused number field can't silently change its value.
    const onWheel = (ev: WheelEvent<HTMLInputElement>) => {
        ev.currentTarget.blur();
    };

    return (
        <InputNumberStyle
            type="number"
            className={readOnly ? "aevi-input aevi-input-number aevi-input-disabled" : "aevi-input aevi-input-number"}
            disabled={readOnly}
            onChange={onValueChange}
            onKeyDown={onKeyDown}
            onWheel={onWheel}
            {...restProps}
        />
    );
};
